import { openMeldRuntimeProfileIdSchema } from "../protocol/profile.js";
import { spaceNameSchema } from "./space-name.js";
import { postSpaceMembersResponseSchema } from "./space-members.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/space-direct-message.ts
const trimmedNonEmptyStringSchema = z$1.string().trim().min(1);
const openDirectMessageSpaceBodySchema = z$1.strictObject({ targetProfileId: openMeldRuntimeProfileIdSchema });
const openDirectMessageSpaceResponseSchema = z$1.strictObject({
	organizationId: trimmedNonEmptyStringSchema,
	memberProfileId: openMeldRuntimeProfileIdSchema,
	targetProfileId: openMeldRuntimeProfileIdSchema,
	spaceId: trimmedNonEmptyStringSchema,
	created: z$1.boolean()
});
const directMessageConversionProfileIdsSchema = z$1.array(openMeldRuntimeProfileIdSchema).min(1).max(100);
const convertDirectMessageToSpaceBodySchema = z$1.strictObject({
	includeMemberSnapshots: z$1.boolean().optional(),
	name: spaceNameSchema,
	profileIds: directMessageConversionProfileIdsSchema
});
const convertDirectMessageToSpaceResponseSchema = z$1.strictObject({
	accessMode: z$1.literal("members_only"),
	addedMemberIds: z$1.array(openMeldRuntimeProfileIdSchema),
	alreadyMemberIds: z$1.array(openMeldRuntimeProfileIdSchema),
	convertedAt: z$1.iso.datetime({ offset: true }),
	items: postSpaceMembersResponseSchema.shape.items.optional(),
	name: spaceNameSchema,
	spaceId: trimmedNonEmptyStringSchema
});
//#endregion
export { convertDirectMessageToSpaceBodySchema, convertDirectMessageToSpaceResponseSchema, openDirectMessageSpaceBodySchema, openDirectMessageSpaceResponseSchema };

//# sourceMappingURL=space-direct-message.js.map